import React, { useEffect, useState } from 'react';
import {
  loadTossPayments,
  TossPaymentsWidgets,
} from '@tosspayments/tosspayments-sdk';

const generateRandomString = (): string =>
  window.btoa(Math.random().toString()).slice(0, 20);
const clientKey = 'live_gck_E92LAa5PVbvEMDOOnZRJV7YmpXyJ';

interface Amount {
  currency: string;
  value: number;
}

interface CheckoutPageProps {
  initialAmount?: Amount;
  orderName?: string; // New prop added
  productIds: string[]; // Change productid to productIds
}

export const CheckoutPage: React.FC<CheckoutPageProps> = ({
  initialAmount,
  orderName, // New prop received
  productIds, // New prop received
}) => {
  console.log(orderName);
  const [ready, setReady] = useState<boolean>(false);
  const [widgets, setWidgets] = useState<TossPaymentsWidgets | null>(null);
  const [amount, setAmount] = useState<Amount>({
    currency: 'KRW',
    value: initialAmount?.value || 0,
  });

  useEffect(() => {
    const fetchPaymentWidgets = async () => {
      const tossPayments = await loadTossPayments(clientKey);
      const user = JSON.parse(localStorage.getItem('user') || '{}');

      if (!user.uuid) {
        console.error('회원의 UUID가 존재하지 않습니다.');
        return;
      }

      const customerKey = String(user.uuid);
      const widgets = tossPayments.widgets({
        customerKey,
      }) as TossPaymentsWidgets;

      setWidgets(widgets);
    };

    fetchPaymentWidgets();
  }, [clientKey]);

  useEffect(() => {
    const renderPaymentWidgets = async () => {
      if (!widgets) {
        return;
      }
      await widgets.setAmount(amount);
      await Promise.all([
        widgets.renderPaymentMethods({
          selector: '#payment-method',
          variantKey: 'DEFAULT',
        }),
        widgets.renderAgreement({
          selector: '#agreement',
          variantKey: 'AGREEMENT',
        }),
      ]);
      setReady(true);
    };

    renderPaymentWidgets();
  }, [widgets, amount]);

  const handlePayment = async () => {
    try {
      const orderId = generateRandomString();
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const customerName = user.fullName || 'Unknown';
      const customerEmail = user.email || 'unknown@example.com';

      // Log productIds to ensure they are not empty
      console.log('Product IDs before payment:', productIds);

      // Create a success and failure URL with the product IDs
      const successUrl = `${
        window.location.origin
      }/success?productIds=${encodeURIComponent(productIds.join(','))}`;
      const failUrl = `${
        window.location.origin
      }/fail?productIds=${encodeURIComponent(productIds.join(','))}`;

      // console.log('Success URL:', successUrl);
      // console.log('Failure URL:', failUrl);
      // console.log('Final Order Name to be sent:', orderName); // Add this log

      await widgets?.requestPayment({
        orderId,
        orderName: orderName ? orderName : 'Default Product Name',
        customerName,
        customerEmail,
        successUrl,
        failUrl,
      });
    } catch (error) {
      console.error('Payment error:', error);
      alert('결제 처리 중 오류가 발생했습니다. 다시 시도해 주세요.'); 
    }
  };

  return (
    <div className="wrapper pb-6">
      <div className="max-w-540 w-[600px] z-[1]">
        <div id="payment-method" className="w-100" />
        <div id="agreement" className="w-100" />
        <div className="btn-wrapper w-100">
          <button
            className="btn primary w-full h-[55px] rounded-full text-lg font-bold bg-[#555] transition duration-300 hover:bg-opacity-80 text-white"
            onClick={handlePayment}
            disabled={!ready}
          >
            결제하기
          </button>
        </div>
      </div>
    </div>
  );
};
